import {
  getColorFromString,
  IButtonStyles,
  IStyle,
  ITheme,
  updateA
} from "@bps/fluent-ui";

const getOpacityColor = (theme: ITheme, opacity: number) =>
  updateA(getColorFromString(theme.palette.neutralLight)!, opacity).str;

export const navBarActionButtonStyles = (
  theme: ITheme,
  isCurrent?: boolean,
  collapse?: boolean
): Partial<IButtonStyles> => {
  const style: IStyle = { color: theme.palette.white };

  return {
    textContainer: !!collapse && {
      ["@media (max-width: 700px)"]: {
        display: "none"
      }
    },
    icon: style,
    menuIcon: style,
    iconHovered: style,
    iconPressed: style,
    root: { background: isCurrent ? getOpacityColor(theme, 25) : "inherit" }
  };
};
